import styled, {css} from 'styled-components'

export const StyledCalendarWrapper = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: ${spacing}px;
        width: 100%;
    `
)

export const StyledCalendarHeader = styled.div(
    ({theme: {palette, spacing, typography}}) => css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        & h3 {
            display: flex;
            gap: ${spacing}px;
            flex-grow: 1;
            text-align: left;
            ${typography.textSm};
            color: ${palette.neutral['950']};
            font-weight: 500;
        }
    `
)

export const StyledDayGrid = styled.div(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-columns: repeat(7, auto);
        row-gap: ${spacing}px;
        width: 100%;
    `
)

export const StyledYearMonthGrid = styled.div(
    ({theme: {spacing}}) => css`
        width: 100%;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: ${spacing * 2}px;
    `
)

export const StyledWeekDayContainer = styled.div(
    ({theme: {palette, typography}}) => css`
        display: flex;
        justify-content: center;
        align-items: center;
        height: 30px;
        ${typography.textXs};
        font-weight: 500;
        color: ${palette.neutral['500']};
    `
)

export const StyledDayButton = styled.button<{
    $isSelected: boolean
    $isInCurrentMonth: boolean
}>(
    ({$isSelected, $isInCurrentMonth, theme: {palette, typography}}) => css`
        position: relative;
        border-radius: 6px;
        height: 30px;
        width: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        ${typography.textXs};

        ${$isSelected &&
        css`
            background-color: ${palette.primary['500']};
            color: ${palette.neutral.white};
            font-weight: 500;
        `}

        ${!$isSelected &&
        $isInCurrentMonth &&
        css`
            color: ${palette.neutral['950']};
            &:hover:not(:disabled) {
                background-color: ${palette.neutral['50']};
            }
        `}

        ${!$isInCurrentMonth &&
        !$isSelected &&
        css`
            color: ${palette.neutral['400']};
        `}

        &:disabled {
            color: ${!$isSelected ? palette.neutral['300'] : palette.neutral['white']};
            cursor: not-allowed;
            text-decoration: line-through;
        }
    `
)

export const StyledTodayIndicator = styled.span<{
    $isSelected: boolean
}>(
    ({$isSelected, theme: {palette}}) => css`
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background-color: ${palette.primary['500']};
        position: absolute;
        bottom: 2px;
        left: 50%;
        transform: translateX(-50%);
        ${$isSelected &&
        css`
            background-color: ${palette.neutral.white};
        `}
    `
)
